<template>
    <CertificationsSection />
</template>

<script>
import CertificationsSection from "@/components/certifications/CertificationsSection.vue";

export default {
    name: "CertificationsView",
    components: {
        CertificationsSection,
    },
};
</script>